export const formatDate = (dateString: string): string => {
  try {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    
    if (isNaN(date.getTime())) {
      return dateString;
    }
    
    const options: Intl.DateTimeFormatOptions = {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZone: 'Asia/Kolkata'
    };
    
    return new Intl.DateTimeFormat('en-GB', options).format(date);
  } catch (error) {
    console.error('Error formatting date:', error);
    return dateString;
  }
};

const shortMonths = ["Jan", "Feb", "Mar", "April", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];

function getDayWithSuffix(day: number): string {
  if (day > 3 && day < 21) return day + "th";
  switch (day % 10) {
    case 1: return day + "st";
    case 2: return day + "nd";
    case 3: return day + "rd";
    default: return day + "th";
  }
}

export function formatDateTime(dateString: string): string {

  if(dateString === ''){
    return '';
  }

  const inputDate = new Date(dateString.replace(" ", "T"));
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  const isToday = inputDate.toDateString() === today.toDateString();
  const isTomorrow = inputDate.toDateString() === tomorrow.toDateString();

  let hours = inputDate.getHours();
  const minutes = inputDate.getMinutes().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  const timeStr = `${hours}:${minutes} ${ampm}`;

  if (isTomorrow) return `Tomorrow, ${timeStr}`;
  if (isToday) return `Today, ${timeStr}`;

  const day = inputDate.getDate();
  const month = shortMonths[inputDate.getMonth()];
  const suffix = getDayWithSuffix(day);
  return `${suffix} ${month}, ${timeStr}`;
}

export function formatDateShort(dateString: string): string {

  if(dateString === ''){
    return '';
  }

  const inputDate = new Date(dateString.replace(" ", "T"));
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  const day = inputDate.getDate();
  const month = shortMonths[inputDate.getMonth()];
  const suffix = getDayWithSuffix(day);
  return `${suffix} ${month}`;
}

export function formatCompleteDate(dateString: string): string {

  if(dateString === ''){
    return '';
  }

  const inputDate = new Date(dateString.replace(" ", "T"));
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  const day = inputDate.getDate();
  const month = shortMonths[inputDate.getMonth()];
  const year = inputDate.getFullYear();
  const suffix = getDayWithSuffix(day);
  return `${suffix} ${month}, ${year}`;
}

export function formatSlotDate(dateString: string): string {
  const dateObj = new Date(dateString);
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  if (dateObj.toDateString() === today.toDateString()) return "Today";
  if (dateObj.toDateString() === tomorrow.toDateString()) return "Tomorrow";

  const day = dateObj.getDate();
  const month = shortMonths[dateObj.getMonth()];
  return `${getDayWithSuffix(day)} ${month}`;
}

export const getMonthFromDate = (dateString: string): string => {
  if (!dateString) return '';
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'long' });
  } catch {
    return '';
  }
};